import Duration from "./duration";

const oneMonthAsDecimal = 1 / 12;

export const getDuration = function(durationAsDecimal: number): Duration {
    const years = Math.floor(durationAsDecimal)

    const fraction = durationAsDecimal - years;
    const months = Math.floor(fraction / oneMonthAsDecimal);
  
    const numerator = getNumerator(months);
    const denominator = getDenominator(months);

    return new Duration(durationAsDecimal, years, months, numerator, denominator);
}

function getNumerator(months: number): number {
    switch (months)
    {
      case 0:
        return 0;
      case 5:
        return 5;
      case 7:
        return 7;
      case 8:
        return 2;
      case 9:
        return 3;
      case 10:
        return 5;
      case 11:
        return 11;
      case 12:
        return 0;
      default:
        return 1;
    }
}

function getDenominator(months: number): number {
    switch (months)
    {
      case 0:
        return 0;
      case 1:
        return 12;
      case 2:
        return 6;
      case 3:
        return 4;
      case 4:
        return 3;
      case 5:
        return 12;
      case 6:
        return 2;
      case 7:
        return 12;
      case 8:
        return 3;
      case 9:
        return 4;
      case 10:
        return 6;
      case 11:
        return 12;
      default:
        return 0;
    }
}
